import { Box, Divider, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import moment from 'moment'
import CustomizedDialogs from '../../common/CustomizedDialogs'
import { checkAndFocus, focusElemnt, navigationWithArrow } from '../../utils/helpers'
import MButton from '../../common/MButton'

const Information = ({ open = false, onClose = () => { }, bkgDeatails = {}, tripTotalAmt, handleGenerateTicket = () => { }, seat }) => {
    const infoList = [
        'Booking Details',
        `Route : ${bkgDeatails?.tripDetails?.SubFromCityName || ''} - ${bkgDeatails?.tripDetails?.SubToCityName || ''}`,
        `Departure Date Time : ${moment(bkgDeatails?.tripDetails?.deptTime, "YYYY-MM-DD HH:mm:ss").format('DD-MMM-YYYY hh:mm A') || ''}`,
        `Arrival Time : ${bkgDeatails?.tripDetails?.ArrivalTime || ''}`,
        `Seat No : ${seat || ''} `,
        `Total Fare = ${tripTotalAmt?.baseFare || '0'} + ${tripTotalAmt?.tax || '0'}  - ${tripTotalAmt?.discount || '0'} + ${tripTotalAmt?.serviceChrg || '0'}  + ${tripTotalAmt?.pickUpChrg || '0'} + ${tripTotalAmt?.dropOffChrg || '0'} = ${tripTotalAmt?.grandAmt || '0'}`,
    ]
    useEffect(() => {
        requestAnimationFrame(() => checkAndFocus(`info-modal-okBnt`));
    }, [bkgDeatails])
    return (
        <CustomizedDialogs padding='0px' open={open} onClose={onClose} width={'auto'} titleText="Information">
            <Box width={'100%'}>
                <Box padding='12px 16px'>
                    {infoList.map((obj, index) => (
                        <Typography sx={{
                            fontWeight: '500',
                            fontSize: '14px',
                            lineHeight: '20px',
                            letterSpacing: '2%',
                            paddingY: '0px',
                            borderBottom: index === 0 || index === 4 || index === 5 ? '2px dashed black' : 'none',
                            paddingBottom: index === 0 || index === 4 || index === 5 ? '10px' : 'none',
                            paddingTop: index === 1 || index === 5 ? '10px' : '0px'
                        }}>{obj}</Typography>
                    ))}
                </Box>
                <Divider />
                <Box sx={{ padding: '10px 16px', gap: '10px', display: 'flex', justifyContent: 'end' }}>
                    <MButton
                        id='info-modal-cancelBnt'
                        variant='outlined'
                        className='btn-orange-outline btnFullwidth'
                        btnName='Cancel' onClick={onClose}
                        onKeyDown={(event) => {
                            navigationWithArrow(event, "info-modal-okBnt", "info-modal-okBnt", () => { onClose() })
                        }}
                    />
                    <MButton
                        id='info-modal-okBnt'
                        btnName='Ok'
                        className='btn-orange btnFullwidth'
                        onClick={handleGenerateTicket}
                        onKeyDown={(event) => {
                            navigationWithArrow(event, "info-modal-cancelBnt", "info-modal-cancelBnt", () => {
                                handleGenerateTicket()
                            })
                        }}

                    />
                </Box>
            </Box>
        </CustomizedDialogs>
    )
}

export default Information